<template>
    <div>
        <!-- 过滤条件 -->
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 180px; margin-right: 15px"
                placeholder="团长等级"
                clearable
                v-model="filter.leaderGrade"
                @on-change="search"
            >
                <Option
                    v-for="item in this.dict.captainLevel.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <!-- 时间 -->
            <DatePicker
                placement="bottom-end"
                style="width: 130px; margin-left: -1px"
                v-model="startDate"
                :class="preCls + 'select-public-style'"
                transfer
                type="date"
                placeholder="开始日期"
                :options="startDateOption"
                @on-change="search"
            ></DatePicker>

            <DatePicker
                style="width: 130px; margin-left: -1px"
                v-model="endDate"
                :class="preCls + 'select-public-style'"
                transfer
                type="date"
                placeholder="结束日期"
                :options="endDateOption"
                @on-change="search"
            ></DatePicker>
            <!-- 减去多少天 -->
            <check-tag-group
                style="display: inline-block"
                v-model="fastDate"
                color="primary"
                @on-change="getEndStart"
            >
                <check-tag
                    v-for="item in fastDateList"
                    :name="item.id"
                    :key="item.id"
                    >{{ item.text }}</check-tag
                >
            </check-tag-group>
        </div>

        <table-tool-bar style="margin-top: 16px">
            <template slot="left">
                <table-searcher
                    v-model="filter.realname"
                    placeholder="请输入姓名"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('add')"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
                >设置分佣比例</Button
            >
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    >详情</Button
                >
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickDetail(row)"
                    >收益明细</Button
                >
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showSRewardForm"
            title="佣金详情"
            :width="800"
            :height="450"
            :maskClosable="false"
        >
            <s-reward-form v-if="modal.showSRewardForm" :id="curId" />
        </smart-modal>
        <smart-modal
            v-model="modal.showSRewardDetailList"
            title="收益明细"
            :width="1000"
            :height="600"
            :maskClosable="false"
            :buttons="rewardBtn"
        >
            <s-reward-detail-list
                v-if="modal.showSRewardDetailList"
                :wxUserId="wxUserId"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showSRewardRateForm"
            title="设置分佣比例"
            :width="1000"
            :height="350"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <s-reward-rate-form v-if="modal.showSRewardRateForm" />
        </smart-modal>
    </div>
</template>
<script>
import { mapCell, pipeCell } from "_c/grid/renderCell";
import SRewardForm from "./s-reward-form";
import SRewardDetailList from "./s-reward-detail-list";
import SRewardRateForm from "./s-reward-rate-form";
import { sRewardList } from "@/api/sell";
import Dict from "_u/dict";
import yzyList from "_v/common/yzy-list";
import { mapCache } from "@/plugins/vux-data-cache";

import dayjs from "dayjs";

const PAGE_SIZE = 20;

export default {
    mixins: [yzyList],
    name: "s-reward-list",

    components: {
        SRewardForm,
        SRewardDetailList,
        SRewardRateForm,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            fastDateList: [
                { id: 7, text: "近7天" },
                { id: 30, text: "近30天" },
                { id: 90, text: "近90天" },
            ],
            fastDate: [],
            // 设置开始时间不可选时间
            startDateOption: {
                disabledDate: (date) => {
                    if (this.endDate === "") {
                        return false;
                    } else if (date.getTime() > this.endDate.getTime()) {
                        return true;
                    }
                },
            },
            // 设置结束时间不可选时间
            endDateOption: {
                disabledDate: (date) => {
                    if (this.startDate === "") {
                        return false;
                    } else if (this.startDate.getTime() > date.getTime()) {
                        return true;
                    }
                },
            },
            curId: "",
            wxUserId: "",
            page: {
                total: 0,
                list: [],
            },
            dict: {
                captainLevel: Dict.NULL,
            },
            modal: {
                showSRewardForm: false,
                showSRewardDetailList: false,
                showSRewardRateForm: false,
            },
            rewardBtn: [{ type: "default", text: "关闭", name: "cancel" }],
        };
    },

    computed: {
        columns() {
            return [
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width: 60,
                },
                {
                    key: "realname",
                    title: "姓名",
                    align: "left",
                    minWidth: 120,
                },
                {
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    minWidth: 120,
                },
                {
                    key: "leaderGrade",
                    title: "等级",
                    align: "center",
                    minWidth: 100,
                    render: mapCell(this.dict.captainLevel.toList()),
                },
                {
                    key: "rate",
                    title: "分佣比例",
                    align: "center",
                    minWidth: 100,
                },
                {
                    key: "totalAmount",
                    title: "累计收益(元)",
                    align: "right",
                    minWidth: 160,
                    render: pipeCell("currency"),
                },
                {
                    key: "freezeAmount",
                    title: "冻结金额(元)",
                    align: "right",
                    minWidth: 160,
                    render: pipeCell("currency"),
                },
                {
                    key: "reflectAmount",
                    title: "可提现金额(元)",
                    align: "right",
                    minWidth: 160,
                    render: pipeCell("currency"),
                },
                {
                    key: "totalReflectAmount",
                    title: "累计提现(元)",
                    align: "right",
                    minWidth: 160,
                    render: pipeCell("currency"),
                },
                {
                    key: "joinTime",
                    title: "加入时间",
                    align: "center",
                    minWidth: 160,

                    render: pipeCell("ymdL"),
                },
                {
                    key: "action",
                    title: "操作",
                    align: "center",
                    width: 180,
                    slot: "action",
                    fixed: "right",
                },
            ];
        },
        startDate: {
            get() {
                return this.filter.startDate
                    ? new Date(this.filter.startDate)
                    : "";
            },
            set(val) {
                this.filter.startDate = val
                    ? dayjs(val).format("YYYY-MM-DD")
                    : "";
            },
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : "";
            },
            set(val) {
                this.filter.endDate = val
                    ? dayjs(val).format("YYYY-MM-DD")
                    : "";
            },
        },
        ...mapCache({
            filter: "sReward",
        }),
    },

    watch: {},

    created() {
        this.fetch();
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80;
        });
    },

    methods: {
        fetch() {
            this.loading = true;

            Promise.all([Dict.get(["captain_level"]), sRewardList(this.filter)])
                .then((args) => {
                    var [dictGroup, page] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    page.data.page.list.forEach((item) => {
                        item.rate = (item.rate * 100).toFixed(2) + "%";
                        item.totalAmount /= 100;
                        item.freezeAmount /= 100;
                        item.reflectAmount /= 100;
                        item.totalReflectAmount /= 100;
                    });
                    this.setPageData(page.data);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        search() {
            this.filter.pageNo = 1;
            this.fetch();
        },

        getEndStart(el) {
            if (el && el.length) {
                this.filter.startDate = dayjs()
                    .subtract(el[0], "day") // 减去多少天
                    .format("YYYY-MM-DD");
                this.filter.endDate = dayjs().format("YYYY-MM-DD");
                this.fetch();
            }
        },

        setPageData(data) {
            this.page.list = data.page.list;
            this.page.total = parseInt(data.page.totalCount);
        },

        onClickAdd(e) {
            this.curId = "";
            this.modal.showSRewardRateForm = true;
        },
        rowClickInfo(row) {
            this.curId = row.id;
            this.modal.showSRewardForm = true;
        },
        rowClickDetail(row) {
            this.wxUserId = row.wxUserId;
            this.modal.showSRewardDetailList = true;
        },
    },
};
</script>
<style lang="less" scoped></style>
